var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-dialog",
        {
          staticClass: "popbox add-new-version",
          attrs: {
            name: "dialog2",
            title: _vm.dialogTitle,
            "close-on-click-modal": "",
            modal: true,
            width: 668,
            "append-to-body": "",
          },
          on: {
            open: _vm.open,
            "after-close": _vm.handleAfterClose,
            confirm: _vm.handleConfirm,
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [
          _c(
            "v-form",
            { ref: "form", attrs: { model: _vm.ruleForm, rules: _vm.rules } },
            [
              _vm.fatherVison
                ? _c(
                    "v-form-item",
                    {
                      staticClass: "fatherInfo",
                      attrs: { label: "父版本信息", prop: "fatherVison" },
                    },
                    [
                      _c("span", { staticClass: "fatherVsion fileUrl" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.fatherProduct) +
                            "_" +
                            _vm._s(_vm.fatherSoftware) +
                            "_" +
                            _vm._s(_vm.fatherVersion_type) +
                            " "
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _c(
                "v-form-item",
                { attrs: { prop: "product_keys" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("产品")]),
                  ]),
                  _c("v-select", {
                    attrs: {
                      isMultiple: "",
                      multipleShowAll: "",
                      id: "product_keys",
                      disabled: _vm.fatherVison != "",
                      insertContains: "product_keys",
                      name: "product_keys",
                      placeholder:
                        _vm.productKeyOptins.length > 0
                          ? "请选择"
                          : "请先新建产品",
                      value: _vm.ruleForm.product_keys,
                      options: _vm.productKeyOptins,
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "software_version", required: true } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("软件版本")]),
                  ]),
                  _c("v-input", {
                    attrs: { type: "text", name: "software_version" },
                    model: {
                      value: _vm.ruleForm.software_version,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "software_version", $$v)
                      },
                      expression: "ruleForm.software_version",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "version_type" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("版本类型")]),
                  ]),
                  _c("v-select", {
                    attrs: {
                      id: "list_version_type",
                      insertContains: "list_version_type",
                      name: "version_type",
                      options: _vm.versionTypeOptions,
                    },
                    model: {
                      value: _vm.ruleForm.version_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "version_type", $$v)
                      },
                      expression: "ruleForm.version_type",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                {
                  staticClass: "listfile",
                  attrs: { prop: "listFile", required: false },
                },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("固件上传")]),
                  ]),
                  _c("v-upload", {
                    ref: "upload",
                    attrs: {
                      action: "/cgi-bin/upload",
                      name: "upload",
                      accept: ".trx,.bin",
                      WfileName: _vm.WfileName,
                      "show-file-list": "",
                      "on-change": _vm.hidemsg,
                    },
                    on: { showtips: _vm.showfiletips },
                  }),
                  _c("div", { ref: "filetip", staticClass: "filetip" }, [
                    _vm._v("未选择文件"),
                  ]),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "hardware_version" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("硬件版本")]),
                  ]),
                  _c("v-input", {
                    attrs: { type: "text", name: "hardware_version" },
                    model: {
                      value: _vm.ruleForm.hardware_version,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "hardware_version", $$v)
                      },
                      expression: "ruleForm.hardware_version",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "version_secret" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("版本密码")]),
                  ]),
                  _c("v-input", {
                    attrs: { type: "text", name: "version_secret" },
                    model: {
                      value: _vm.ruleForm.version_secret,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "version_secret", $$v)
                      },
                      expression: "ruleForm.version_secret",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "enterprise_name" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("企业名称")]),
                  ]),
                  _c("v-input", {
                    attrs: { type: "text", name: "enterprise_name" },
                    model: {
                      value: _vm.ruleForm.enterprise_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "enterprise_name", $$v)
                      },
                      expression: "ruleForm.enterprise_name",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "disabled_cloud" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("是否禁用云服务")]),
                  ]),
                  _c("v-radio", {
                    staticClass: "options",
                    attrs: {
                      name: "disabled_cloud",
                      options: _vm.disabledCloudOptions,
                    },
                    model: {
                      value: _vm.ruleForm.disabled_cloud,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "disabled_cloud", $$v)
                      },
                      expression: "ruleForm.disabled_cloud",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "recursion" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("是否跳过当前版本")]),
                  ]),
                  _c("v-radio", {
                    staticClass: "options",
                    attrs: { name: "recursion", options: _vm.recursionList },
                    model: {
                      value: _vm.ruleForm.recursion,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "recursion", $$v)
                      },
                      expression: "ruleForm.recursion",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "system" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("系统")]),
                  ]),
                  _c("v-input", {
                    attrs: { type: "text", name: "system" },
                    model: {
                      value: _vm.ruleForm.system,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "system", $$v)
                      },
                      expression: "ruleForm.system",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "author_description" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("作者描述")]),
                  ]),
                  _c("v-input", {
                    staticClass: "Description",
                    attrs: {
                      type: "textarea",
                      name: "author_description",
                      maxlength: 200,
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.ruleForm.author_description,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "author_description", $$v)
                      },
                      expression: "ruleForm.author_description",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "language" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("语言")]),
                  ]),
                  _c("v-checkbox-group", {
                    attrs: { name: "language", options: _vm.languageOptions },
                    on: { click: _vm.handleClick },
                    model: {
                      value: _vm.languageDataArr,
                      callback: function ($$v) {
                        _vm.languageDataArr = $$v
                      },
                      expression: "languageDataArr",
                    },
                  }),
                  _c(
                    "div",
                    [
                      _c(
                        "v-button",
                        {
                          attrs: { type: "primary", name: "btn-s", size: "S" },
                          on: { click: _vm.showAddLag },
                        },
                        [_vm._v("添加语言")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _vm._l(_vm.languageDataArr, function (item, index) {
                return _c(
                  "v-form-item",
                  {
                    key: index,
                    staticClass: "descp-language",
                    attrs: { prop: "descpSelect" },
                  },
                  [
                    _c(
                      "v-form-item",
                      { attrs: { prop: "change_log" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticClass: "required" }),
                          _c("span", [
                            _vm._v("更新日志(" + _vm._s(item) + ")"),
                          ]),
                        ]),
                        _c("v-input", {
                          staticClass: "Description",
                          attrs: {
                            type: "textarea",
                            name: "change_log",
                            maxlength: 200,
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.ruleForm.descp_lang[index].change_log,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ruleForm.descp_lang[index],
                                "change_log",
                                $$v
                              )
                            },
                            expression: "ruleForm.descp_lang[index].change_log",
                          },
                        }),
                      ],
                      2
                    ),
                    _c(
                      "v-form-item",
                      { attrs: { prop: "new_func" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticClass: "required" }),
                          _c("span", [_vm._v("新功能(" + _vm._s(item) + ")")]),
                        ]),
                        _c("v-input", {
                          staticClass: "Description",
                          attrs: {
                            type: "textarea",
                            name: "new_func",
                            maxlength: 200,
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.ruleForm.descp_lang[index].new_func,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ruleForm.descp_lang[index],
                                "new_func",
                                $$v
                              )
                            },
                            expression: "ruleForm.descp_lang[index].new_func",
                          },
                        }),
                      ],
                      2
                    ),
                    _c(
                      "v-form-item",
                      { attrs: { prop: "optimization" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticClass: "required" }),
                          _c("span", [
                            _vm._v("优化内容(" + _vm._s(item) + ")"),
                          ]),
                        ]),
                        _c("v-input", {
                          staticClass: "Description",
                          attrs: {
                            type: "textarea",
                            name: "optimization",
                            maxlength: 200,
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.ruleForm.descp_lang[index].optimization,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ruleForm.descp_lang[index],
                                "optimization",
                                $$v
                              )
                            },
                            expression:
                              "ruleForm.descp_lang[index].optimization",
                          },
                        }),
                      ],
                      2
                    ),
                    _c(
                      "v-form-item",
                      { attrs: { prop: "memo" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticClass: "required" }),
                          _c("span", [_vm._v("备注(" + _vm._s(item) + ")")]),
                        ]),
                        _c("v-input", {
                          staticClass: "Description",
                          attrs: {
                            type: "textarea",
                            name: "memo",
                            maxlength: 200,
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.ruleForm.descp_lang[index].memo,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.ruleForm.descp_lang[index],
                                "memo",
                                $$v
                              )
                            },
                            expression: "ruleForm.descp_lang[index].memo",
                          },
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _c("v-loading", {
            staticClass: "loading-box",
            attrs: { visible: !_vm.upTips, name: "loading4" },
          }),
        ],
        1
      ),
      _c("addLag", {
        ref: "add",
        attrs: { showAddDialog: _vm.AddLoading },
        on: {
          "update:showAddDialog": function ($event) {
            _vm.AddLoading = $event
          },
          "update:show-add-dialog": function ($event) {
            _vm.AddLoading = $event
          },
          change: function ($event) {
            return _vm.showAddLag()
          },
          addNewLag: _vm.addNewLag,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }